import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Style from "./style";
import StoreTicket from "./ui/StoreTicket";
import SeedTicket from "./ui/SeedTicket";
import ParticipationTicket from "./ui/ParticipationTicket";

import MainHeader from "widget/MainHeader";

import useGetAccountDetail from "entity/account/useGetAccountDetail";
import usePutAccountBan from "entity/account/usePostAccountBan";
import useDeleteAccountBan from "entity/account/useDeleteAccountBan";

import DTStyle from "shared/style/detailTableStyle";
import { convertProGradeAsName } from "shared/constant/lookup/proGrade";
import timestampCalculator from "shared/lib/timestampCalculator";
import useConfirmModalAtom from "shared/model/useConfirmModalAtom";
import useRoleCookie from "shared/model/useRoleCookie";
import { ROLE_SUPER_ADMIN } from "shared/constant/lookup/role";
import DefaultButton from "shared/ui/DefaultButton";
import useLoginCookie from "shared/model/useLoginCookie";
import useConfrimCookie from "shared/model/useConfrimCookie";
import useAlertModalAtom from "shared/model/useAlertModalAtom"


/**
 * @Desc 유저상세 페이지
 * @Access 최고관리자 프로자격 기능추가(2025.08.31)
 */
const UserDetail = () => {
  const [userData] = useGetAccountDetail();
  const [banUser] = usePutAccountBan();
  const [unbanUser] = useDeleteAccountBan();

  console.log(userData)

  const [roleCookie] = useRoleCookie();
  const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie();

  const [, setConfrimEvent] = useConfirmModalAtom();

  const [cookie, , deleteCookie] = useLoginCookie();
  
  const [selectedValue, setSelectedValue] = useState(1);
  const { idx } = useParams();
  const [, setAlert] = useAlertModalAtom()
  const lastSelect = userData?.data?.grade_history[userData?.data?.grade_history?.length - 1] || 0;
  const utcDate = new Date(lastSelect?.time);
  utcDate.setHours(utcDate.getHours());
  const mapperDate = utcDate.toLocaleString();
  

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const submitLevel = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/admin/account/${idx}/grade`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: cookie,
          confirm: confirmCookie,
        },
        body: JSON.stringify({"new_grade_flag":selectedValue}),
      }
    );


    switch (response.status) {
      case 200:
        window.location.reload()
        break;
      case 400:
        setAlert("현재 등급과 동일합니다.")
        break
      default:
        alert("서버에러가 발생 했습니다.");
    }
  }

  useEffect(() => {
    if (userData) {
      setSelectedValue(userData?.data?.pro_grade_flag);
    }
  }, [userData]);

  const btnList = [];
  roleCookie === ROLE_SUPER_ADMIN &&
    btnList.push({
      label: userData?.data?.is_ban ? "정지 해지" : "정지",
      clickEvent: () => {
        userData?.data?.is_ban
          ? setConfrimEvent(
              "해당 사용자의 정지를 해지하시겠습니까?",
              () => unbanUser
            )
          : setConfrimEvent(
              "해당 사용자가 더 이상 로그인을 할 수 없게 됩니다.\n정말 정지하시겠습니까?",
              () => banUser
            );
      },
      deactive: false,
    });

  const userDataList = [
    {
      label: "IDX",
      value: userData?.data?.idx,
    },
    {
      label: "아이디",
      value: userData?.data?.id || "-",
    },
    {
      label: "이름",
      value: userData?.data?.name,
    },
    {
      label: "닉네임",
      value: userData?.data?.nickname,
    },
    {
      label: "연락처",
      value: `+${userData?.data?.international_number} ${userData?.data?.contact}`,
    },
    {
      label: "프로 자격",
      value: convertProGradeAsName[userData?.data?.pro_grade_flag],
    },
    {
      label: "상태",
      value: userData?.data?.is_ban ? "정지" : "정상",
    },
    {
      label: "프리미엄",
      value: userData?.data?.is_premium ? "활성" : "미활성",
    },
    {
      label: "가입 날짜",
      value: timestampCalculator(userData?.data?.created_at),
    },
  ];
  const profileImg = userData?.data?.profile_img;

  const tabList = ["매장 이용권", "시드권", "참가권"];
  const [tab, setTab] = useState(tabList[0]);

  return (
    <Style.Wrapper>
      <MainHeader btnList={btnList} />

      <Style.AreaDiv>
        <h2>사용자 계정 데이터</h2>
        <DTStyle.TableDiv>
          {userDataList?.map((elem) => (
            <DTStyle.TableElement>
              <h2>{elem?.label}</h2>
              <p>{elem?.value}</p>
            </DTStyle.TableElement>
          ))}
        </DTStyle.TableDiv>
      </Style.AreaDiv>

    {roleCookie === ROLE_SUPER_ADMIN && (<Style.QualAreaDiv>
        <h2 onClick={() => console.log(selectedValue)}>프로 자격</h2>
        <div className="_selectArea">
          <Style.TableDiv>
            <Style.TableElement>
              <h2>{"자격요건"}</h2>
              <select
                className="_select"
                value={selectedValue}
                onChange={handleSelectChange}
              >
                <option value={1}>없음</option>
                <option value={2}>베이직 루키프로</option>
                <option value={3}>루키프로</option>
                <option value={4}>베이직 세미프로</option>
                <option value={5}>세미프로</option>
                <option value={6}>베이직 투어프로</option>
                <option value={7}>투어프로</option>
              </select>
            </Style.TableElement>
          </Style.TableDiv>
          <DefaultButton fitWidth small clickEvent={() => setConfrimEvent("사용자 자격을 변경하시겠습니까?", ()=>submitLevel)}>
            변경
          </DefaultButton>
        </div>

        <Style.TableDiv>
          <Style.TableElement>
            <h2>{"자격시작일"}</h2>
            <p>{mapperDate}</p>
          </Style.TableElement>
        </Style.TableDiv>
      </Style.QualAreaDiv>)}
      

      {profileImg && (
        <Style.AreaDiv>
          <h2>프로필 이미지</h2>
          <div>
            <Style.LogoImg src={profileImg} />
          </div>
        </Style.AreaDiv>
      )}

      <Style.TabDiv>
        {tabList.map((elem) => (
          <Style.Tab $selected={tab === elem} onClick={() => setTab(elem)}>
            {elem}
          </Style.Tab>
        ))}
      </Style.TabDiv>

      {tab === tabList[0] && <StoreTicket />}
      {tab === tabList[1] && <SeedTicket />}
      {tab === tabList[2] && <ParticipationTicket />}
    </Style.Wrapper>
  );
};

export default UserDetail;
